import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import BlockWithTextAndLink from './src/components/BlockWithTextAndLink';
import { IngredientsBlock } from './src/components/IngretientsBlock';
import { Retailers } from './src/components/Retailers';
import ReviewsSection from './src/components/ReviewsSection';
import { SelectorBanner } from './src/components/SelectorBanner';
import { Separator } from './src/components/Separator';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'separator',
        component: Separator,
      },
      {
        key: 'custom-ingredients-block',
        component: IngredientsBlock,
      },
      {
        key: 'custom-selector-banner',
        component: SelectorBanner,
      },
      {
        key: 'custom-retailers',
        component: Retailers,
      },
      {
        key: 'reviews-section',
        component: ReviewsSection,
      },
      {
        key: 'block-with-text-and-link',
        component: BlockWithTextAndLink,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
